import { render, staticRenderFns } from "./competency-chart-card.vue?vue&type=template&id=59f83367&scoped=true&"
import script from "./competency-chart-card.ts?vue&type=script&lang=ts&"
export * from "./competency-chart-card.ts?vue&type=script&lang=ts&"
import style0 from "./competency-chart-card.vue?vue&type=style&index=0&id=59f83367&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f83367",
  null
  
)

export default component.exports